export var defaultLaunchHelixOnboardingPlanPromptDefault = 'Helix Trial Onboarding';